module.exports = "/images/hsbc.png?d3991bf2cae8cc3b3a6ec77fa3236df8";